export const arrayToObject = (array, key) =>
  array.reduce((acc, item, index) => {
    acc[item[key] || index] = item;

    return acc;
  }, {});

export const flattenByField = (array, field) =>
  array.reduce(
    (acc, item) =>
      Array.isArray(item[field]) ? acc.concat(item[field]) : acc.concat(item),
    []
  );
